module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.998/img/screenshot-og.png"